import { useMemo, useState } from 'react';

import { EventMetaFilter, PublicFeedEvent } from '@shared/types/event';

import { useAnalytics } from '@hooks/useAnalytics';

export const useEventMetaFilter = (
  events: PublicFeedEvent[],
  filters: EventMetaFilter[],
  initialFilterValue: string | undefined,
) => {
  const { track } = useAnalytics();
  const [filterValue, setFilterValue] = useState(initialFilterValue);

  const currentFilter = useMemo(() => {
    if (filterValue) {
      return filters.find((f) => f.value === filterValue);
    }
    return undefined;
  }, [filterValue, filters]);

  const filteredEvents = useMemo(
    () => (filterValue ? events.filter((event) => event[filterValue]) : events),
    [filterValue, events],
  );

  const updateFilterValue = (value: string) => {
    track('Update Event Meta Filter', { filterValue: value });
    setFilterValue(value);
  };

  return { filterValue, updateFilterValue, currentFilter, filteredEvents };
};
